import RootRouter from "../routers/RootRouter";
import LoaderProvider from './LoaderProvider';
import { AuthServiceClass } from '../components/Authentication/AuthServiceClass';
import AuthProvider from './AuthProvider';
import ListProvider from "./ListProvider";
import ArchivedListProvider from "./ArchivedListProvider";
import BudgetDetailProvider from "./BudgetDetailProvider";

const AppProvider = () => {

    const authService = new AuthServiceClass({
        clientId: import.meta.env.VITE_CLIENT_ID,
        location: window.location,
        strLocation: import.meta.env.VITE_APP_CALLBACK_URL,
        provider: import.meta.env.VITE_COGNITO_SERVICE_URL,
        redirectUri: import.meta.env.VITE_APP_CALLBACK_URL,
        scopes: [
          "openid",
          "profile",
          import.meta.env.VITE_COGINITO_ADDITIONAL_SCOPE,
        ],
    });

    return (
        <>
            <AuthProvider authService={authService}>
                <LoaderProvider>
                    <BudgetDetailProvider>
                        <ArchivedListProvider>
                            <ListProvider>
                                <RootRouter />
                            </ListProvider>
                        </ArchivedListProvider>
                    </BudgetDetailProvider>
                </LoaderProvider>
            </AuthProvider>
        </>
    )
}

export default AppProvider;